import compact from 'lodash/compact'

import { Currency } from 'src/types/currency'

export const displayCurrencyUnit = (currency?: Currency) => currency?.symbol || currency?.code || ''

export const getPriceDisplay = ({
  price,
  currency,
}: {
  price: string | number
  currency?: Currency
}) => compact([price?.toString(), displayCurrencyUnit(currency)]).join(' ')

export const getPricePerUnitDisplay = (
  price: string | number,
  currency: Currency | undefined,
  quantityUnitSlug: string
) => `${getPriceDisplay({ price, currency })}/${quantityUnitSlug}`
